import React from "react";
import Link from "../components/Link";
import useRoute from "../hooks/useRoute";
import { ACCOUNT_NAV } from "./accountNav";

export default function AccountMenu({ className = "", onNavigate }) {
  const route = useRoute();
  return (
    <nav className={className} aria-label="Account">
      <ul className="flex flex-col gap-1">
        {ACCOUNT_NAV.map((item) => {
          const active = route.path === item.to;
          return (
            <li key={item.to}>
              <Link
                to={item.to}
                aria-current={active ? "page" : undefined}
                onClick={onNavigate}
                className={[
                  "flex min-h-11 items-center rounded-xl px-3 text-sm font-medium transition",
                  active ? "bg-bg1 text-ink" : "text-ink/80 hover:bg-bg1 hover:text-ink",
                ].join(" ")}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
